var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"editorjs-render-column  p-2 d-flex justify-content-center"},[_c('Editorjsrender',{attrs:{"align_style":_vm.align_style,"scroll":false,"blocks_json":_vm.block.blocks}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }